import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { View } from 'react-native';
import { DETAILS_SCREENS_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import BatchTimeLine from '@v2/pages/batch/details/modules/batch/components/BatchTimeline/BatchTimeline';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { LoadSingleBatch } from '@interfaces/methods';
import { isWeb } from '@helpers';
import { fullWidth, width } from '@components/frame';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsBatchTimelineProps {
  loadSingleBatch: LoadSingleBatch;
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const JobDetailsBatchTimelineComponent: FC<JobDetailsBatchTimelineProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  batch,
  loadSingleBatch,
}) => {
  const title = useTitle();

  useJobDetails({
    operationsSearch,
    updateHeaderConfig,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    loadSingleBatch,
  });

  return (
    <JobContentWrapper loading={false} title={title.batch}>
      <View
        style={{
          ...DETAILS_SCREENS_CONTAINER_STYLES,
          marginInline: 'auto',
          width: '100%',
        }}
      >
        <BatchTimeLine
          productionBatchId={batch?.data?.productionBatchId ?? undefined}
          width={isWeb ? fullWidth : width}
          withoutList
          horizontalOffset={SCREEN_PADDING_HORIZONTAL * 2}
        />
      </View>
    </JobContentWrapper>
  );
};

const JobDetailsBatchTimeline = connect(({ batch: { batch } }) => ({ batch }), {
  operationsSearch,
  updateHeaderConfig,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  loadSingleBatch,
})(JobDetailsBatchTimelineComponent);

export { JobDetailsBatchTimeline };
